import React from "react"
import {CustomerSearch, Document, Cart, CustomerDetails, Wix} from "../pages"
import {Routes as RouterRoutes, Route, useParams} from "react-router-dom"
import {BrowserRouter} from "react-router-dom"
import NavigatorInjector from "../utils/NavigatorInjector"
import Layout from "../componenets/layout/Layout"
import Orders from "../componenets/order/Orders"
import LineItemInfo from "../componenets/order/lineItem/LineItemInfo"
import {useLocation} from "react-router-dom"
import {LegacyCustomerOrders} from "@commercehub/order"
const Routes = () => {
	return (
		<BrowserRouter>
			<NavigatorInjector />
			<Layout>
				<div>
					<main role="main">
						<RouterRoutes>
							<Route path="/customer-search" element={<CustomerSearch />} />
							<Route path="/customer" element={<Orders customerId={getCustomerId()} />} />
							<Route path="/orders">
								<Route index element={<OrdersIndexWrapper />} />
								<Route path=":orderNumber" element={<OrderDetailWrapper />} />
								<Route
									path=":orderNumber/items/:itemId"
									element={<LineItemInfo customerId={getCustomerId()} />}
								/>
							</Route>
							<Route path="/documents" element={<Document />} />
							<Route path="/cart" element={<Cart />} />
							<Route path="/customer-details" element={<CustomerDetails />} />
							<Route path="/wix" element={<Wix />} />
						</RouterRoutes>
					</main>
				</div>
			</Layout>
		</BrowserRouter>
	)
}

export default Routes

export const OrdersIndexWrapper = () => {
	const routerLocation = useLocation()

	const customerId = new URLSearchParams(routerLocation.search).get("shopper_id") || ""

	return (
		<div style={{padding: "16px"}}>
			<LegacyCustomerOrders shopperId={customerId} accountId={"ozoDdrmewShEcbUDWX8J3V"} />
		</div>
	)
}

export const OrderDetailWrapper = () => {
	const {orderNumber} = useParams()

	return (
		<div style={{padding: "16px"}}>
			<LegacyCustomerOrders
				shopperId={getCustomerId()}
				orderNumber={orderNumber}
				accountId={"ozoDdrmewShEcbUDWX8J3V"}
			/>
		</div>
	)
}

export function getCustomerId(): string {
	const shopperId = new URLSearchParams(window.location.search).get("shopper_id")
	return shopperId ? shopperId : ""
}

export function getTenantId(): string {
	const tenantId = new URLSearchParams(window.location.search).get("tenantId")
	return tenantId ? tenantId : "VP-IE-PROD"
}

export function updateURLParameter(url: string, param: string, paramVal: string) {
	var newAdditionalURL = ""
	var tempArray = url.split("?")
	var additionalURL = tempArray[1]
	var temp = ""
	if (additionalURL) {
		tempArray = additionalURL.split("&")
		for (var i = 0; i < tempArray.length; i++) {
			if (tempArray[i].split("=")[0] !== param) {
				newAdditionalURL += temp + tempArray[i]
				temp = "&"
			}
		}
	}

	var rows_txt = temp + "" + param + "=" + paramVal
	return "?" + newAdditionalURL + rows_txt
}
